module.exports = __webpack_public_path__ + "img/img39.f2c445a8.png";